import React, { useState } from "react";
import "./ToS.css";
import { FiChevronDown } from "react-icons/fi";

const ToS = () => {
  const [activeSection, setActiveSection] = useState(null);

  const sections = [
    {
      title: "1. Sobre estes Termos",
      content: (
        <>
          <p>
            Estes Termos de Serviço estabelecem as condições para utilização
            do site egelemprestimos.com.br, bem como das informações,
            conteúdos e canais de contato disponibilizados pela Egel.
          </p>

          <p>
            Ao acessar e utilizar o site, o usuário declara estar de acordo
            com estes Termos e com a legislação brasileira aplicável.
          </p>
        </>
      ),
    },
    {
      title: "2. Finalidade do Site",
      content: (
        <>
          <p>
            O site tem finalidade institucional e informativa, apresentando
            informações sobre os serviços, soluções e formas de atendimento
            disponibilizados pela Egel.
          </p>

          <p>
            O site também pode disponibilizar canais para que o usuário entre
            em contato com a empresa e manifeste interesse em determinados
            serviços.
          </p>

          <p>
            Nenhuma operação financeira, contratação de crédito, liberação de
            valores ou movimentação financeira é realizada diretamente por
            meio deste site.
          </p>
        </>
      ),
    },
    {
      title: "3. Uso do Site",
      content: (
        <>
          <p>
            O usuário compromete-se a utilizar o site de forma adequada,
            respeitando a legislação vigente e os direitos da empresa e de
            terceiros.
          </p>

          <p>Não é permitido:</p>

          <ul>
            <li>Utilizar o site para fins ilícitos ou fraudulentos;</li>
            <li>
              Fornecer informações falsas, incorretas ou obtidas de terceiros
              sem autorização;
            </li>
            <li>
              Tentar comprometer, interromper ou prejudicar o funcionamento do
              site;
            </li>
            <li>
              Realizar tentativas de acesso não autorizado a sistemas ou
              informações da empresa;
            </li>
            <li>
              Reproduzir ou utilizar indevidamente conteúdos protegidos do
              site.
            </li>
          </ul>
        </>
      ),
    },
    {
      title: "4. Informações Disponibilizadas",
      content: (
        <>
          <p>
            As informações apresentadas no site têm caráter informativo e
            podem ser alteradas, atualizadas ou removidas a qualquer momento,
            sem aviso prévio.
          </p>

          <p>
            A disponibilização de informações sobre determinado serviço não
            representa, por si só, garantia de contratação, aprovação,
            disponibilidade ou concessão de qualquer produto ou serviço.
          </p>

          <p>
            Quando aplicável, condições específicas serão apresentadas pelos
            responsáveis pela prestação ou contratação do serviço.
          </p>
        </>
      ),
    },
    {
      title: "5. Canais de Atendimento",
      content: (
        <>
          <p>
            O site poderá disponibilizar canais de atendimento, como
            formulários, telefone, WhatsApp, e-mail ou outros meios de
            comunicação.
          </p>

          <p>
            O envio de uma mensagem ou solicitação por meio desses canais não
            implica contratação automática de qualquer serviço.
          </p>

          <p>
            O atendimento poderá depender da disponibilidade da equipe e das
            informações fornecidas pelo usuário.
          </p>
        </>
      ),
    },
    {
      title: "6. Informações Fornecidas pelo Usuário",
      content: (
        <>
          <p>
            Ao preencher formulários ou entrar em contato com a empresa, o
            usuário se compromete a fornecer informações verdadeiras,
            completas e atualizadas.
          </p>

          <p>
            O usuário é responsável pela exatidão das informações fornecidas
            e pelos efeitos decorrentes do fornecimento de dados incorretos
            ou de terceiros sem a devida autorização.
          </p>
        </>
      ),
    },
    {
      title: "7. Privacidade e Proteção de Dados",
      content: (
        <>
          <p>
            O tratamento de dados pessoais realizado por meio do site observa
            a legislação aplicável, especialmente a Lei Geral de Proteção de
            Dados Pessoais (Lei nº 13.709/2018 – LGPD).
          </p>

          <p>
            As informações sobre coleta, utilização, armazenamento,
            compartilhamento e direitos dos titulares estão descritas em
            nossa Política de Privacidade.
          </p>

          <p>
            O usuário poderá solicitar informações ou exercer seus direitos
            relacionados aos seus dados pessoais por meio dos canais oficiais
            disponibilizados pela empresa.
          </p>
        </>
      ),
    },
    {
      title: "8. Cookies e Tecnologias Semelhantes",
      content: (
        <>
          <p>
            O site poderá utilizar cookies e tecnologias semelhantes para
            garantir seu funcionamento, melhorar a experiência de navegação,
            compreender a utilização do site e, quando aplicável, oferecer
            conteúdos mais relevantes.
          </p>

          <p>
            O usuário pode gerenciar determinadas preferências relacionadas a
            cookies por meio das configurações do navegador ou dos mecanismos
            disponibilizados pelo próprio site.
          </p>
        </>
      ),
    },
    {
      title: "9. Propriedade Intelectual",
      content: (
        <>
          <p>
            Os elementos presentes no site, incluindo textos, imagens,
            fotografias, logotipos, marcas, identidade visual, códigos,
            layout e demais conteúdos, são protegidos pela legislação
            aplicável.
          </p>

          <p>
            É proibida a reprodução, alteração, distribuição ou utilização
            comercial desses conteúdos sem autorização prévia, quando exigida
            pela legislação.
          </p>
        </>
      ),
    },
    {
      title: "10. Links e Serviços de Terceiros",
      content: (
        <>
          <p>
            O site poderá conter links, referências ou direcionamentos para
            páginas, serviços ou plataformas de terceiros.
          </p>

          <p>
            Esses conteúdos possuem suas próprias regras, termos e políticas.
            A Egel não se responsabiliza por conteúdos, práticas ou
            informações disponibilizadas por terceiros fora de seus canais
            oficiais.
          </p>
        </>
      ),
    },
    {
      title: "11. Disponibilidade do Site",
      content: (
        <>
          <p>
            A Egel busca manter o site disponível e funcionando
            adequadamente, mas não garante que o acesso será ininterrupto ou
            livre de falhas.
          </p>

          <p>
            O site poderá ficar temporariamente indisponível para manutenção,
            atualizações, melhorias ou por circunstâncias que estejam fora do
            controle da empresa.
          </p>
        </>
      ),
    },
    {
      title: "12. Limitação de Responsabilidade",
      content: (
        <>
          <p>
            A Egel não será responsável por prejuízos decorrentes de
            informações incorretas fornecidas pelo usuário, indisponibilidade
            temporária do site ou utilização inadequada de seus conteúdos.
          </p>

          <p>
            As informações disponíveis no site não substituem documentos,
            contratos, condições específicas ou orientações fornecidas pelos
            responsáveis pela prestação de determinado serviço.
          </p>
        </>
      ),
    },
    {
      title: "13. Alterações destes Termos",
      content: (
        <>
          <p>
            Estes Termos poderão ser atualizados periodicamente para refletir
            alterações no site, nos serviços oferecidos ou na legislação
            aplicável.
          </p>

          <p>
            A versão mais recente estará disponível nesta página, sendo
            recomendável que o usuário consulte os Termos sempre que utilizar
            o site.
          </p>
        </>
      ),
    },
    {
      title: "14. Encerramento e Restrição de Acesso",
      content: (
        <>
          <p>
            A Egel poderá restringir ou suspender o acesso ao site ou a
            determinados recursos quando identificar utilização indevida,
            tentativa de fraude, violação destes Termos ou outras situações
            que possam comprometer a segurança e o funcionamento da
            plataforma.
          </p>
        </>
      ),
    },
    {
      title: "15. Legislação Aplicável",
      content: (
        <>
          <p>
            Estes Termos são regidos pelas leis da República Federativa do
            Brasil.
          </p>

          <p>
            Eventuais questões relacionadas à utilização do site serão
            analisadas de acordo com a legislação brasileira aplicável,
            observadas as regras legais de competência e proteção ao
            consumidor.
          </p>
        </>
      ),
    },
    {
      title: "16. Informações da Empresa",
      content: (
        <>
          <p>
            O site é operado por:
          </p>

          <ul>
            <li>
              <strong>Egel</strong> — CNPJ nº 21.945.243/0001-72
            </li>
            <li>
              <strong>Crefins</strong> — CNPJ nº 30.186.700/0001-83
            </li>
          </ul>

          <p>Para entrar em contato conosco:</p>

          <ul>
            <li>
              E-mail: fernando@egelemprestimos.com.br
            </li>
            <li>
              Telefone: +55 49 9995-7692
            </li>
          </ul>
        </>
      ),
    },
  ];

  const toggleSection = (index) => {
    setActiveSection(activeSection === index ? null : index);
  };

  return (
    <section id="termos-serviço" className="section tos">
      <div className="container tos-container">
        <div className="section-content section-head tos-head">
          <h2 className="title">Termos de Serviço</h2>

          <p className="subtitle">
            Consulte as condições para utilização do nosso site e dos canais
            de atendimento.
          </p>
        </div>

        <div className="faq-list">
          {sections.map((section, index) => {
            const active = activeSection === index;

            return (
              <article
                className={`faq-item ${active ? "active" : ""}`}
                key={section.title}
              >
                <button
                  type="button"
                  className="faq-question"
                  onClick={() => toggleSection(index)}
                  aria-expanded={active}
                >
                  <span>{section.title}</span>

                  <span className="faq-icon">
                    <FiChevronDown size={18} />
                  </span>
                </button>

                <div className="faq-answer">
                  <div className="faq-answer-content">
                    {section.content}
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ToS;